export default {
  section1: {
    odeCategory: false,
    name: false,
    sector: false,
    commercialBussines: false,
    nationality: false,
    registrationYear: false,
    city: false,
    state: false,
  },
  section2: {
    businessName: false,
    personType: false,
    rfc: false,
    commercialAddress: false,
    physicalAddress: false,
  },
  section2Foreign: {
    businessName: false,
    ein: false,
    inc: false,
    commercialAddress: false,
    physicalAddress: false,
  },
  section3: {
    website: false,
    facebook: false,
    twitter: false,
    instagram: false,
    email: false,
  },
  section4: {
    phase: false,
    technology: false,
    trl: false,
    industry: false,
    area: false,
  },
};
